<template>
    <div v-if="translation" class="d-flex align-items-center">
        <b-badge :variant="badgeVariant" class="badge-language">
            <span class="flag-icon mr-25" :class="flagIconCode" />
            <span class="text-dark mr-50">{{ translation.LanguageCode.toUpperCase() }}: </span>
            <span
                :class="{
                    'text-muted': !translation.Title,
                    'text-dark': !!translation.Title,
                }"
            >
                {{ translation.Title || "(Çeviri Girilmemiş)" }}
            </span>
        </b-badge>
    </div>
    <span v-else class="text-muted">Çeviri Yok</span>
</template>

<script>
import "flag-icon-css/css/flag-icons.min.css";
import { BBadge } from "bootstrap-vue";

export default {
    name: "TranslationSummaryBadge",
    components: {
        BBadge,
    },
    props: {
        field: {
            type: Array,
            default: () => [],
        },
        row: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        translation() {
            if (this.field && this.field.length > 0) {
                return this.field[0];
            }
            return null;
        },
        flagIconCode() {
            if (!this.translation) return "flag-icon-xx";

            let code;
            switch (this.translation.LanguageCode) {
                case "en":
                    code = "gb";
                    break;
                case "tr":
                    code = "tr";
                    break;
                default:
                    code = "xx";
            }
            return `flag-icon-${code}`;
        },
        badgeVariant() {
            if (!this.translation || !this.translation.LanguageCode) {
                return "light-secondary";
            }

            switch (this.translation.LanguageCode.toLowerCase()) {
                case "tr":
                    return "light-danger";
                case "en":
                    return "light-primary";
                default:
                    return "light-secondary";
            }
        },
    },
};
</script>

<style scoped>
.badge-language {
    display: inline-flex;
    align-items: center;
}
</style>
